import React, { useReducer, useCallback, useState } from "react";
import { Modal, Button, Form, Spinner, CloseButton } from "react-bootstrap";
import { toast } from "react-toastify";

const initialState = { questionText: "", active: true };

const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.name]: action.value };
    case "TOGGLE_ACTIVE":
      return { ...state, active: !state.active };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

const AddSecurityQuestionModal = ({ show, onClose, addSecurityQuestion, fetchSecurityQuestions }) => {
  const [formData, dispatch] = useReducer(formReducer, initialState);
  const [submitting, setSubmitting] = useState(false);

  const handleClose = useCallback(() => {
    onClose();
    dispatch({ type: "RESET" });
  }, [onClose]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    dispatch({ type: "UPDATE_FIELD", name, value });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.questionText.trim()) {
      toast.error("Question Text is required");
      return;
    }

    setSubmitting(true);

    try {
      await addSecurityQuestion(formData);        // ← exactly what was working before
      toast.success("Security question added successfully!"); // ← ONLY THIS IS NEW
      await fetchSecurityQuestions();
      handleClose();
    } catch (error) {
      toast.error("Failed to add security question");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} keyboard={!submitting} backdrop="static">
      <Modal.Header className="bg-body-tertiary border-0">
        <Modal.Title style={{ fontSize: 14 }} className="ps-2">
          Add Security Question
        </Modal.Title>
        <CloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="px-4 py-0 pb-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Question Text</Form.Label>
            <Form.Control
              type="text"
              name="questionText"
              placeholder="Enter security question"
              value={formData.questionText}
              onChange={handleChange}
              disabled={submitting}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="active-switch"
              label={formData.active ? "Active (visible)" : "Inactive (hidden)"}
              checked={formData.active}
              onChange={() => dispatch({ type: "TOGGLE_ACTIVE" })}
              disabled={submitting}
            />
          </Form.Group>

          <div className="d-flex gap-2 mt-4">
            <Button variant="secondary" onClick={handleClose} disabled={submitting}>
              Close
            </Button>
            {submitting ? (
              <Spinner animation="border" size="md" variant="success" />
            ) : (
              <Button type="submit" variant="success">
                Add
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddSecurityQuestionModal;